var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCommunicationEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.943.442s1.89-.783 1.89 1.852v16.985c0 2.634-1.89 1.852-1.89 1.852-2.792-1.896-5.058-3.154-7.085-3.99v5.866c0 .365-.302.66-.673.66h-3.153a.666.666 0 0 1-.673-.66v-7.233c-2.147-.384-3.324-.24-4.208-.276h-.52c-.57 0-1.033-.453-1.033-1.013V7.088c0-.56.463-1.013 1.034-1.013h.519c2.518-.046 6.372.763 15.792-5.633ZM4.422 6.67l.082.006a.908.908 0 0 1 .811.895v6.386a.91.91 0 0 1-.919.901l.026-.002-.15-.003c-2.176-.104-3.989-1.811-4.1-3.94l-.005-.208c0-2.293 1.977-4.035 4.316-4.035h-.061Z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B8B7B7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.322 56.604h-4.065l-1.44-1.39c5.042-5.866 8.078-13.482 8.078-21.766C66.895 14.974 51.921 0 33.448 0 14.974 0 0 14.974 0 33.448 0 51.92 14.974 66.895 33.448 66.895c8.284 0 15.9-3.036 21.766-8.079l1.39 1.441v4.065L82.333 90 90 82.333l-25.678-25.73Zm-30.874 0c-12.813 0-23.156-10.343-23.156-23.156 0-12.813 10.343-23.156 23.156-23.156 12.813 0 23.156 10.343 23.156 23.156 0 12.813-10.343 23.156-23.156 23.156Z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(19 21)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCommunicationEmpty);
export default __webpack_public_path__ + "static/media/ic-communication-empty.e627c853f34223672eceac2f207461b5.svg";
export { ForwardRef as ReactComponent };